import { toast } from "react-toastify";
import MapApi from "../map/api";
import ConfigSectorsApi from "./api";
import ConfigSectorsTypes from "./types";
import IntlUtils from "services/intl/utils";
import ConfigSectorsUtils from "./utils";

class ConfigSectorsActioner {
  static setInitialized(value) {
    return {
      type: ConfigSectorsTypes.SET_INITIALIZED,
      value,
    };
  }

  static setLoadingAreas(value) {
    return {
      type: ConfigSectorsTypes.SET_AREAS_LOADING,
      value,
    };
  }

  static setAreas(data) {
    return {
      type: ConfigSectorsTypes.SET_AREAS,
      data,
    };
  }

  static setAreaSelected(id) {
    return {
      type: ConfigSectorsTypes.SET_AREA_SELECTED,
      value: id,
    };
  }

  static setLoadingSectors(value) {
    return {
      type: ConfigSectorsTypes.SET_SECTORS_LOADING,
      value,
    };
  }

  static setSectors(data) {
    return {
      type: ConfigSectorsTypes.SET_SECTORS,
      data,
    };
  }

  static setSectorsData(data) {
    return {
      type: ConfigSectorsTypes.SET_SECTORS_DATA,
      data,
    };
  }

  static intializeModule = () => {
    return (dispatch) => {
      dispatch(ConfigSectorsActioner.setInitialized(false));

      return dispatch(ConfigSectorsActioner.retrieveAreas()).then((res) => {
        dispatch(
          ConfigSectorsActioner.retrieveSectorsByAreas(
            res?.areas?.map((a) => a.id)
          )
        );
        return res;
      });
    };
  };

  static retrieveAreas = () => {
    return (dispatch, getState) => {
      dispatch(ConfigSectorsActioner.setLoadingAreas(true));

      const data = {
        contract_id: getState().Contract.contract.id,
        types: ["PARKANDFLOW", "PEDESTRIANANDFLOW"],
      };

      const { config } = getState()?.Map;
      const mapParkingConfig = config?.parking || {};

      return MapApi.getAreasInfos(data)
        .then((res) => {
          dispatch(
            ConfigSectorsActioner.setAreas(
              ConfigSectorsUtils.filterAreasByMapConfig(
                res?.areas,
                mapParkingConfig?.areas
              )
            )
          );
          return res;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    };
  };

  static retrieveSectorsByAreas = (ids) => {
    return (dispatch, getState) => {
      const areas = getState().ConfigSectors.areas;

      if (ids?.length > 0) {
        const data = {
          area_ids: ids.join(","),
        };
        const intl = IntlUtils.getIntlInstance();

        return ConfigSectorsApi.getSectorsByArea(data)
          .then((res) => {
            dispatch(ConfigSectorsActioner.setSectors(res?.areas));
            dispatch(
              ConfigSectorsActioner.setAreas(
                areas.items?.filter(
                  (a) =>
                    res?.areas?.find(
                      (areaSector) => areaSector.area_id === a.id
                    )?.sectors?.length > 0
                )
              )
            );
            dispatch(ConfigSectorsActioner.setInitialized(true));
          })
          .catch((err) => {
            let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
            if (err.status === 403) {
              msg = intl.formatMessage({ id: "toast.errors.sectors.resource" });
            }

            toast(msg, {
              position: toast.POSITION.BOTTOM_RIGHT,
              type: toast.TYPE.ERROR,
            });
            return Promise.reject(err);
          });
      }
      dispatch(ConfigSectorsActioner.setInitialized(true));
    };
  };

  static retrieveSectorsData = () => {
    return (dispatch, getState) => {
      dispatch(ConfigSectorsActioner.setLoadingSectors(true));
      const sectors = getState()
        .ConfigSectors.sectors.items.map((area) =>
          area.sectors.map((sector) => sector.id)
        )
        ?.flat();
      const filter = {
        sector_ids: sectors,
      };
      const intl = IntlUtils.getIntlInstance();

      return ConfigSectorsApi.getSectorsData(filter)
        .then((res) => {
          dispatch(ConfigSectorsActioner.setSectorsData(res?.sectors));
          dispatch(ConfigSectorsActioner.setLoadingSectors(false));
        })
        .catch((err) => {
          let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
          if (err.status === 403) {
            msg = intl.formatMessage({ id: "toast.errors.sectors.action" });
          }

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
          return Promise.reject(err);
        });
    };
  };

  static updateSector = (id, data, previousData) => {
    return (dispatch, getState) => {
      const contractId = getState().Contract.contract.id;
      const intl = IntlUtils.getIntlInstance();
      return ConfigSectorsApi.updateSector(id, {
        ...data,
        previous_value: previousData,
        contract_id: contractId,
      })
        .then((res) => {
          let msg = intl.messages["toast.success.updateSectorSuccess"];

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.SUCCESS,
          });
          dispatch(ConfigSectorsActioner.setAreaSelected(undefined));
          return res;
        })
        .catch((error) => {
          let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
          if (error.status === 403) {
            msg = intl.formatMessage({ id: "toast.errors.sectors.action" });
          }

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
          return Promise.reject(error);
        });
    };
  };
}

export default ConfigSectorsActioner;
